/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
// © Microsoft Corporation. All rights reserved.
import React, { useEffect, useState, useRef } from 'react';
import { Separator, Pivot, PivotItem, Stack, CommandButton } from '@fluentui/react';
import { AudioDeviceInfo, Call, LocalVideoStream, VideoDeviceInfo, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
import MediaControls from './MediaControls';
import { CommandPanelTypes } from './CommandPanel';
import { UserFriendsIcon, SettingsIcon, ChatIcon, HandIcon } from '@fluentui/react-icons-northstar';
import { Constants, URLOptionsConstants } from 'core/constants';
import {
    headerContainer,
    pivotItemStyles,
    separatorContainerStyle,
    separatorStyles,
    pivotItemStyle,
    headerCenteredContainer,
    notificationStyle
} from './styles/Header.styles';
import { ParticipantStream } from 'core/reducers';

import {
    //getNewMessages,
    resetNewMessages,
    toggleChatSound,
    SignalRUserConnect,
    responseCandidateSettings,
    readCandidateSettings,
    hasMicToggled,
    SetSelectedCamera,
    SetSelectedMicrophone,
    ImageAnalyze
} from '../core/sideEffects';

import {
    IsCandidateMode,
    IsInterlocutorMode,
    UserCommand,
    IsHiddenMode,
    DeviceType,
    IsProctorMode,
    IsCentralScreenMode,
    IsSecondaryStream
} from 'Utils/Utils';
import { connection, signalR, StartSignalR } from 'App';
import { setAudioDeviceInfo, setVideoDeviceInfo } from '../core/actions/devices';

export interface HeaderProps {
    userId: string
    selectedPane: CommandPanelTypes;
    setSelectedPane: any;
    endCallHandler(): void;
    actionable: boolean;
    localVideo: boolean;
    mic: boolean;
    shareScreen: boolean;
    call: Call;
    endCall(): void;
    screenShareStreams: ParticipantStream[];
    activeScreenShareStream: ParticipantStream | undefined;
    localVideoRendererIsBusy: boolean;
    cameraPermission: string;
    microphonePermission: string;
    screenWidth: number;
    setMic(mic: boolean): void;
    setLocalVideoStream(localVideoStream: LocalVideoStream | undefined): void;
    setScreenShare(screenShare: boolean): void;
    isLocalScreenShareSupportedInBrowser(): boolean;
    localVideoStream: LocalVideoStream | undefined;
    videoDeviceInfo: VideoDeviceInfo | undefined;
    videoDeviceList: VideoDeviceInfo[] | undefined;
    audioDeviceInfo: AudioDeviceInfo | undefined;
    audioDeviceList: AudioDeviceInfo[] | undefined;
    setVideoDeviceInfo(device: VideoDeviceInfo): void;
    setAudioDeviceInfo(device: AudioDeviceInfo): void;
    localPreview: boolean;
    setLocalPreview(localPreview: boolean): void;
    helpClicked: boolean;
    SendHelpMessage(helpClicked: boolean): void
}

export class CommunicationObject {
    UserCommandType: number | undefined;
    Content: string | undefined;

    constructor() {
    }
}

const refreshCandidatePage = () => {

    window.location.reload();
};

export const toggleCamera = () => {
    let input: HTMLElement = document.getElementById('CameraButtonId') as HTMLElement;
    if (input != null) {
        input.click();
        var event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
    }
};

export const toggleVideoDropDownList = () => {
    let video: HTMLElement = document.getElementById('drpVideo') as HTMLElement;
    if (video != null) {
        var event = new Event('input', { bubbles: true });
        video.dispatchEvent(event);
    }
}

const triggerVolumeUp = () => {
    let input: HTMLElement = document.getElementById('triggerHiddenVolumeUp') as HTMLElement;
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const selectedMicrophone = urlParams.get(URLOptionsConstants.MICROPHONEINDEX);
    let innertext = selectedMicrophone;
    if (input != null) {
        if (innertext) {
            input.innerText = innertext;
            input.hidden = true;
            input.click();
            input.innerText = '';
        }
    }
};

const triggerVolumeDown = () => {
    let input: HTMLElement = document.getElementById('triggerHiddenVolumeDown') as HTMLElement;
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const selectedMicrophone = urlParams.get(URLOptionsConstants.MICROPHONEINDEX);
    let innertext = selectedMicrophone;
    if (input != null) {
        if (innertext) {
            input.innerText = innertext;
            input.hidden = true;
            input.click();
            input.innerText = '';
        }
    }
};

const newMessageReceived = () => {
    console.log('TeamsClient: triggered the button newMessageReceived');
};
export default (props: HeaderProps): JSX.Element => {
    const [cameraDisabled, setCameraDisabled] = useState(props.cameraPermission === 'Denied' ? false : (IsCandidateMode() || IsHiddenMode()));
    
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const cloudToolsEnabled = urlParams.get(URLOptionsConstants.CLOUDTOOLSENABLED);
    const threadId = urlParams.get(URLOptionsConstants.THREADID);
    type IntervalId = ReturnType<typeof setInterval>;
    const listenerRef = useRef<IntervalId | null>(null);

    const togglePeople = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        return selectedPane !== CommandPanelTypes.People
            ? setSelectedPane(CommandPanelTypes.People)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const toggleOptions = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        return selectedPane !== CommandPanelTypes.Settings
            ? setSelectedPane(CommandPanelTypes.Settings)
            : setSelectedPane(CommandPanelTypes.None);
    };
    const toggleChat = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        if (selectedPane !== CommandPanelTypes.Chat) {
            resetNewMessages(true);
        }
        else {
            resetNewMessages(false);
        }

        return selectedPane !== CommandPanelTypes.Chat
            ? setSelectedPane(CommandPanelTypes.Chat)
            : setSelectedPane(CommandPanelTypes.None);
    };
    const handleChatSoundOnOff = (): void => {
        var isVisible = document.visibilityState !== 'hidden';
        var isChatVisible = props.selectedPane === CommandPanelTypes.Chat;
        if (IsCentralScreenMode()) {
            toggleChatSound(false);
        }
        else if (!isVisible) {
            toggleChatSound(true);
        }
        else if (!isChatVisible) {
            toggleChatSound(true);
        }
        else {
            toggleChatSound(false);
        }
    };
    const handleLocalVideoOnOff = async (isLocalClick: boolean): Promise<void> => {
        try {
            if (cameraDisabled && isLocalClick) return; 
            setCameraDisabled(true);
            if (props.call.localVideoStreams) {
                try {
                    var videoStream = props.call.localVideoStreams.filter((stream) => stream.mediaStreamType === 'Video');
                    if (props.call.localVideoStreams.length > 0 && videoStream.length > 0) {
                        await props.call.stopVideo(videoStream[0]);
                        props.setLocalVideoStream(undefined);
                        if (listenerRef.current != null) {
                            clearInterval(listenerRef.current);
                            listenerRef.current = null;
                        }
                    }
                    else {
                        if (props.videoDeviceInfo) {
                            const localVideoStream = new LocalVideoStream(props.videoDeviceInfo);
                            props.setLocalVideoStream(localVideoStream);
                            await props.call.startVideo(localVideoStream);
                            await checkCloudTools(localVideoStream);
                        }
                    }
                } catch(err)
                {
                    console.error('Settings:' + err);
                }
                
            }
            
        }
        catch (e) {
            console.error('Settings:' + e);

            const multipleClicksErrCode = 4;
            if ((e as any)?.code === multipleClicksErrCode && props.videoDeviceInfo)
            {
                if (props.localVideoStream)
                    await props.call.stopVideo(props.localVideoStream);
                const localVideoStream = new LocalVideoStream(props.videoDeviceInfo);
                props.setLocalVideoStream(localVideoStream);
            }
        }
        finally {
            if (IsCandidateMode()) {
                if (props.call.localVideoStreams) {
                    var videoStream = props.call.localVideoStreams.filter((stream) => stream.mediaStreamType === 'Video');
                    if (props.call.localVideoStreams.length > 0 && videoStream.length > 0) {
                        setCameraDisabled(true);
                    }
                    else {
                        setCameraDisabled(false);
                    }
                }
            }
            else { setCameraDisabled(false); }
        }
    };
    const handleLocalVideoOn = async (): Promise<void> => {
        try {

            if (!props.localVideoStream && props.videoDeviceInfo) {
                const localVideoStream = new LocalVideoStream(props.videoDeviceInfo);
                props.setLocalVideoStream(localVideoStream);
                await props.call.startVideo(localVideoStream);
                await checkCloudTools(localVideoStream);
            }
        }
        catch (e) {
            console.error('Settings:' + e);
        }
    };
    const handleLocalVideoOff = async (): Promise<void> => {
        try {
            if (props.localVideoStream) {
                try {
                    await props.call.stopVideo(props.localVideoStream);

                    if (listenerRef.current!=null) {
                        clearInterval(listenerRef.current);
                        listenerRef.current = null;
                    }
                } catch { }
                props.setLocalVideoStream(undefined);
            }
        }
        catch (e) {
            console.error('Settings:' + e);
        }
    };
    const checkCloudTools = async (localVideoStream: LocalVideoStream): Promise<void> => {
        try {
            if (localVideoStream && listenerRef.current == null) {
                if (IsCandidateMode() && threadId && cloudToolsEnabled && cloudToolsEnabled.toLowerCase() === 'true') {

                    let localVideoStreamRenderer = new VideoStreamRenderer(localVideoStream);
                    let localViewCapture = await localVideoStreamRenderer.createView({ scalingMode: 'Fit', isMirrored: true });
                    const ImageAnalyzeInterval = 10;//configjson.CloudToolsImageAnalyzeInterval;
                    listenerRef.current = setInterval(() => {
                        Capture(localViewCapture, threadId);
                    }, ImageAnalyzeInterval * 1000);
                }
            }
        }
        catch (e) {
            console.error('checkCloudTools:' + e);
        }
    };
    const Capture = (localViewCapture : VideoStreamRendererView, threadId : string): void => {
        let videoCanvas = document.createElement('canvas');
        var view = localViewCapture.target;

        if (view) {
            let video = view.firstChild as HTMLVideoElement;

            if (video) {
                videoCanvas.height = video.videoHeight;
                videoCanvas.width = video.videoWidth;
                let context = videoCanvas.getContext('2d');
                
                if (context) {
                    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
            
                    let imgSrc = videoCanvas.toDataURL('image/jpg');
                    let stringBase64 = imgSrc.split(',')[1];
            
                    if (stringBase64.length > 0)
                        ImageAnalyze(stringBase64, threadId);
                }
            }
        }
    };

    //const handleLocalVideoOnOffSignalR = async (): Promise<void> => {
    //    if (!cameraIsActive()) { // && !IsCandidateMode()) {
    //        try {
    //            if (props.call.localVideoStreams[0]) {
    //                console.log('Settings: 31');
    //                await props.call.stopVideo(props.call.localVideoStreams[0]);
    //                console.log('Settings: 32');
    //            }
    //            else if (props.localVideoStream) {
    //                console.log('Settings: 41');
    //                await props.call.stopVideo(props.localVideoStream);
    //                console.log('Settings: 42');

    //            }
    //            props.setLocalVideoStream(undefined);
    //            //isCameraOn = false;
    //        }
    //        catch (e) {
    //            console.error("SignalR: " + e);
    //        }
    //    } else {
    //        if (props.videoDeviceInfo) {
    //            const localVideoStream = new LocalVideoStream(props.videoDeviceInfo);
    //            props.setLocalVideoStream(localVideoStream);
    //            await props.call.startVideo(localVideoStream);
    //            //isCameraOn = true;
    //        }
    //    }
    //};

    //TODO: Remove comments in future.
    // The set mic for the Candidate was removed from here and it's set in the sideeffects
    const handleMuteOnOff = (): void => {
        //if (IsCandidateMode())
        //    props.setMic(IsCandidateMode());
        //else
        props.setMic(!props.mic);
    };

    const TrySetUpdatedDevice = (deviceName: string, index: number, deviceType: DeviceType): void => {
        try {
            if (deviceType === DeviceType.Camera) {
                try {
                    setTimeout(function () {
                        toggleCamera();
                    }, 500);

                    props.videoDeviceList?.forEach((data) => {
                        if (data.name === deviceName) {
                            setVideoDeviceInfo(data);
                            props.setVideoDeviceInfo(data);
                        }
                    });
                    SetSelectedCamera(index);

                    setTimeout(function () {
                        toggleCamera();
                    }, 500);
                }
                catch (e) {
                    console.error('Settings:' + e);
                }
            }
            else if (deviceType === DeviceType.Microphone) {
                props.audioDeviceList?.forEach((data) => {
                    if (data.name === deviceName) {
                        setAudioDeviceInfo(data);
                        props.setAudioDeviceInfo(data);
                    }
                });

                SetSelectedMicrophone(index);
            }
        } catch (error) {
            console.error('Settings: Failed to TrySetUpdatedDevice, Error: ', error);
        }
    };
    const micIsActive = (): boolean => {
        return props.mic; // || IsCandidateMode();
    }

    const cameraIsActive = (): boolean => {
        return props.localVideoStream !== undefined; // || IsCandidateMode();
    }

    const localPreviewIsActive = (): boolean => {
        return props.localPreview;
    }

    const handleLocalPreviewOnOff = (): void => {
        props.setLocalPreview(!props.localPreview);
    };

    const handleScreenSharingOnOff = (): void => {
        props.setScreenShare(!props.shareScreen);
    };

    useEffect(() => {
        document.addEventListener("visibilitychange", handleChatSoundOnOff);

        return () => { document.removeEventListener("visibilitychange", handleChatSoundOnOff); };
    }, [handleChatSoundOnOff])

    useEffect(() => {
        handleChatSoundOnOff();
    }, [props.selectedPane])

    useEffect( () => {
        if (props.call && props.call.localVideoStreams.length === 0 && props.localVideoStream) {
            props.call.startVideo(props.localVideoStream);
            checkCloudTools(props.localVideoStream);
        }

        return  ()  => {
            if (listenerRef.current != null) {
                clearInterval(listenerRef.current);
                listenerRef.current = null;
            }
        }
    }, [props.call, props.localVideoStream]);

    var locked = false;
    useEffect(() => {
        connection.on("UserCommunication", (data: string) => {
            if (connection.state === signalR.HubConnectionState.Connected) {
                let dataObj: CommunicationObject = Object.assign(new CommunicationObject(), JSON.parse(data));

                if (dataObj.UserCommandType === UserCommand.Response) {
                    console.log("SignalR: UserCommand.Response Received");
                }
                if (dataObj.UserCommandType === UserCommand.ToggleMicrophone) {
                    if (IsCandidateMode()) {
                        try {
                            if (hasMicToggled !== true) {
                                props.setMic(true);
                            }
                            else {
                                props.setMic(false);
                            }
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.ToggleCamera) {
                    if (IsCandidateMode() || IsSecondaryStream()) {
                        try {
                            if (!locked) {
                                locked = true;
                                toggleCamera();                        
                                setTimeout(function () {
                                    locked = false;
                                }, 5000);
                            }
                            
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.IncreaseVolume) {
                    if (IsCandidateMode()) {
                        try {
                            triggerVolumeUp();
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.DecreaseVolume) {
                    if (IsCandidateMode()) {
                        try {
                            triggerVolumeDown();
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.ToggleScreenSharing) {
                    if (IsCandidateMode()) {
                        try {
                            document.getElementById("screenShareButton")?.click();
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.RequestSettings) {
                    if (IsCandidateMode() || IsSecondaryStream()) {
                        try {
                            const urlParams = new URLSearchParams(window.location.search.substring(1));
                            const threadId = urlParams.get(URLOptionsConstants.THREADID);
                            if (threadId)
                                responseCandidateSettings(threadId);
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.ResponseSettings) {
                    if (IsInterlocutorMode() || IsProctorMode()) {
                        try {
                            if (dataObj.Content) {
                                readCandidateSettings(dataObj.Content);
                            }
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.TryUpdateCandidateCamera) {
                    if (IsCandidateMode() || IsSecondaryStream()) {
                        try {
                            if (dataObj.Content) {
                                const myArray = dataObj.Content.split("@@@");
                                let index: number = Number(myArray[1]);
                                let device: string = myArray[0].toString();
                                console.log('Settings: TrySetUpdatedDevice, device: ' + device + ', index: ' + index);
                                TrySetUpdatedDevice(device, index, DeviceType.Camera);
                            }
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.TryUpdateCandidateMicrophone) {
                    if (IsCandidateMode()) {
                        try {
                            if (dataObj.Content) {
                                const myArray = dataObj.Content.split("@@@");
                                let index: number = Number(myArray[1]);
                                let device: string = myArray[0].toString();
                                console.log('Settings: TrySetUpdatedDevice');
                                TrySetUpdatedDevice(device, index, DeviceType.Microphone);
                            }
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
                else if (dataObj.UserCommandType === UserCommand.RefreshCandidatePage) {
                    if (IsCandidateMode() || IsSecondaryStream()) {
                        try {
                            refreshCandidatePage();
                        } catch (e) {
                            console.error('SignalR: ' + e);
                        }
                    }
                }
            }
        }
        );

        connection.onclose(error => {
            if (error) {
                console.error('SignalR: ' + error);
            }
            console.log("SignalR: Connection.onclose");

            setTimeout(function () {
                StartSignalR();

                setTimeout(function () {
                    const urlParams = new URLSearchParams(window.location.search.substring(1));
                    const threadId = urlParams.get(URLOptionsConstants.THREADID);
                    const userId = urlParams.get(URLOptionsConstants.USERID);
                    if (threadId && userId)
                        SignalRUserConnect(threadId, userId);
                }, 100);
            }, 100);
        });

        connection.onreconnected(connectionId => {
            console.log("SignalR: Connection.onreconnected");
            console.log("SignalR: Connection state " + connection.state);
            console.log("SignalR: Connection id " + connection.connectionId);

            console.assert(connection.state === signalR.HubConnectionState.Connected);
            if (connection.state === signalR.HubConnectionState.Connected) {
                console.log("SignalR: signalRUserConnect ");

                console.log("SignalR: Connection id " + connection.connectionId);

                setTimeout(function () {
                    const urlParams = new URLSearchParams(window.location.search.substring(1));
                    const threadId = urlParams.get(URLOptionsConstants.THREADID);
                    const userId = urlParams.get(URLOptionsConstants.USERID);
                    if (threadId && userId)
                        SignalRUserConnect(threadId, userId);
                }, 100);
            }
        });

        connection.onreconnecting((error) => {
            if (error) {
                console.error('SignalR: ' + error);
            }
            console.log("SignalR: Connection.onreconnecting");
        });

        //added in case the on event is not triggered many times but itsnot working
        return () => {
            connection.off("UserCommunication", (data: string) => {
            });
        };
    }, [/*connection, props.setMic, props.mic, IsCandidateMode, props.signalRUserConnect*/]);


    return (
        <Stack
            id="header" style={{ display: IsCentralScreenMode() || IsSecondaryStream() ? 'none' : '' }}
            className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? headerContainer : headerCenteredContainer}
        >
            <CommandButton
                id={"newMessageReceived"}
                hidden={true}
                onClick={newMessageReceived}
            />
            {!IsHiddenMode() && (
                <Pivot
                    onKeyDownCapture={(e): void => {
                        if ((e.target as HTMLElement).id === CommandPanelTypes.People && e.keyCode === 39) e.preventDefault();
                    }}
                    getTabId={(itemKey: string): string => itemKey}
                    onLinkClick={(item): void => {
                        if (!item) return;
                        if (item.props.itemKey === CommandPanelTypes.Settings)
                            toggleOptions(props.selectedPane, props.setSelectedPane);
                        if (item.props.itemKey === CommandPanelTypes.People)
                            togglePeople(props.selectedPane, props.setSelectedPane);
                        if (item.props.itemKey === CommandPanelTypes.Chat) {
                            toggleChat(props.selectedPane, props.setSelectedPane);
                        }
                    }}
                    styles={pivotItemStyles}
                    initialSelectedKey={CommandPanelTypes.None}
                    selectedKey={props.selectedPane}
                >
                    <PivotItem
                        itemKey={CommandPanelTypes.Settings}
                        onRenderItemLink={(): JSX.Element => (
                            <SettingsIcon
                                outline={props.selectedPane === CommandPanelTypes.Settings ? false : true}
                                size="medium"
                                className={pivotItemStyle}
                                onClick={() => resetNewMessages(false)}
                            />
                        )}
                    />
                    {!(IsCandidateMode() || IsInterlocutorMode() || IsProctorMode()) && (
                        <PivotItem
                            itemKey={CommandPanelTypes.People}
                            onRenderItemLink={(): JSX.Element => (
                                <UserFriendsIcon
                                    outline={props.selectedPane === CommandPanelTypes.People ? false : true}
                                    size="medium"
                                    className={pivotItemStyle}
                                    onClick={() => resetNewMessages(false)}
                                />
                            )}
                        />
                    )}
                    <PivotItem
                        id="ChatButtonId"
                        itemKey={CommandPanelTypes.Chat}
                        className={pivotItemStyle}
                        onRenderItemLink={(): JSX.Element => (
                            <React.Fragment>
                                <ChatIcon
                                    outline={props.selectedPane === CommandPanelTypes.Chat ? false : true}
                                    size="medium"
                                    className={pivotItemStyle}

                                />
                                <span
                                    id="spanIconBadge"
                                    className={notificationStyle}
                                //onClick={() => { props.selectedPane === CommandPanelTypes.Chat ? () => resetNewMessages(true) : () => resetNewMessages(false) }}
                                >
                                </span>

                            </React.Fragment>
                        )}>
                    </PivotItem>
                    {IsCandidateMode() && (
                        <PivotItem
                            id="HelpButtonId"
                            itemKey={CommandPanelTypes.HelpButton}
                            onRenderItemLink={(): JSX.Element => (
                                <HandIcon
                                    outline={props.selectedPane === CommandPanelTypes.Chat ? false : true}
                                    size="medium"
                                    className={pivotItemStyle}
                                    onClick={() => props.SendHelpMessage(props.helpClicked)}
                                />
                            )}
                        />
                    )}

                    <PivotItem
                        itemKey={CommandPanelTypes.None}
                        onClick={() => resetNewMessages(false)}
                    />

                </Pivot>
            )}

            {props.screenWidth > Constants.SEPARATOR_HEADER_WINDOW_WIDTH && (
                <div className={separatorContainerStyle}>
                    <Separator styles={separatorStyles} vertical={true} />
                </div>
            )}
            <MediaControls
                micActive={micIsActive()}
                onMicChange={handleMuteOnOff}
                cameraActive={cameraIsActive()}
                onCameraChange={(isLocalClick) => handleLocalVideoOnOff(isLocalClick)}
                startCamera={handleLocalVideoOn}
                stopCamera={handleLocalVideoOff}
                screenShareActive={props.shareScreen}
                activeScreenShareStream={props.screenShareStreams[0] ?? undefined}
                onScreenShareChange={handleScreenSharingOnOff}
                onEndCallClick={(): void => {
                    if (props.call.localVideoStreams)
                    {
                        var videoStream = props.call.localVideoStreams.filter((stream) => stream.mediaStreamType === 'Video');
                        if (props.call.localVideoStreams.length > 0 && videoStream.length > 0)
                            handleLocalVideoOnOff(true);
                    }
                    props.endCall();
                }}
                cameraPermission={props.cameraPermission}
                microphonePermission={props.microphonePermission}
                localVideoRendererIsBusy={props.localVideoRendererIsBusy}
                compressedMode={props.screenWidth <= Constants.MINI_HEADER_WINDOW_WIDTH}
                isLocalScreenShareSupportedInBrowser={props.isLocalScreenShareSupportedInBrowser}
                localPreviewActive={localPreviewIsActive()}
                onLocalPreviewClick={handleLocalPreviewOnOff}
                cameraDisabled={cameraDisabled}
            />
        </Stack>
    );
};